/**
 * Date and time utility functions for messaging
 */

/**
 * Format time in 12-hour format with AM/PM
 */
export const formatTime = (isoTime?: string): string => {
  if (!isoTime) return '';
  const date = new Date(isoTime);
  return date.toLocaleTimeString([], { 
    hour: '2-digit', 
    minute: '2-digit',
    hour12: true 
  });
};

/**
 * Get relative date label for message grouping
 */
export const getRelativeDateLabel = (isoTime?: string): string => {
  if (!isoTime) return '';
  
  const messageDate = new Date(isoTime);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  
  // Remove time component for comparison
  const messageDateOnly = new Date(messageDate.getFullYear(), messageDate.getMonth(), messageDate.getDate());
  const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const yesterdayOnly = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());
  
  if (messageDateOnly.getTime() === todayOnly.getTime()) {
    return 'Today';
  } else if (messageDateOnly.getTime() === yesterdayOnly.getTime()) {
    return 'Yesterday';
  } else {
    // Format as "Jan 15, 2025" for older dates
    return messageDate.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  }
};

/**
 * Check if two messages are from different days
 */
export const isDifferentDay = (currentMessageTime?: string, previousMessageTime?: string): boolean => {
  if (!currentMessageTime || !previousMessageTime) return true;
  
  const currentDate = new Date(currentMessageTime);
  const previousDate = new Date(previousMessageTime);
  
  return currentDate.toDateString() !== previousDate.toDateString();
};

/**
 * Sort messages by time
 */
export const sortMessagesByTime = <T extends { time?: string; $createdAt?: string }>(
  messages: T[], 
  docs?: any[]
): T[] => {
  return messages.sort((a, b) => {
    let timeA = a.time || (docs?.find((d: any) => d.$id === (a as any).$id)?.$createdAt) || '';
    let timeB = b.time || (docs?.find((d: any) => d.$id === (b as any).$id)?.$createdAt) || '';
    
    return new Date(timeA).getTime() - new Date(timeB).getTime();
  });
};
